import { CurrencyPipe } from "@angular/common";
import { AbstractControl, FormControl } from "@angular/forms";
import { FormlyFieldConfig } from "@ngx-formly/core";

/**
 * 
 * @param control Control that has the validatior defined
 * @param form Complete form
 * @param options A validation function specific option object. 
 * Example: { data: { date: "fieldName1", condition: ">"}}
 * @returns true if validation passed. An object with the validation id and a message property inside if failed. Example: { "date": { message: "Something went wrong"}}
 */
export function pastYearValidator(control: AbstractControl, form: FormlyFieldConfig, options: any = {}) {
  const constructionYear = control.value;
  let flag: boolean = false;
  let message: string = '';

  try {
    if (constructionYear === undefined) {
      return null;
    }

    const cYear = constructionYear;

    const currentYear = (new Date().getFullYear());

    // TODO: Check If Construction Year is required

    if (cYear === null) {
      if (control.pristine) {
        return null;
      } else {
        // TODO: Check the situation for + and - values. Field becomes required. Model will retun null.
        // flag = true;
        // message = "Construction year should be number."

        return null;
      }

    } else if (cYear < 1000) {
      flag = true;
      message = "Construction year should be after year of 1000."
    } else if (cYear >= currentYear) {
      flag = true;
      message = "Construction year should be before current year."
    } else {
      flag = false;
    }

  } catch (err) {
    console.warn(err);
  }


  return flag ? {
    'year': {
      message: options.data.message || message
    }
  } : null;
}

